import React from "react";
import discovery from "../../common/images/crm-work-1.png";
import integration from "../../common/images/crm-work-3.png";
import deployment from "../../common/images/crm-work-4.png";
import support from "../../common/images/crm-work-2.png";
import chartImage from "../../common/images/crm-last-img.png";

const steps = [
  {
    image: discovery,
    title: "Discovery",
    highlight: "& Planning",
    description: "We analyze your business needs and design a tailored CRM solution.",
  },
  {
    image: integration,
    title: "Development",
    highlight: "& Integration",
    description: "We build and integrate the CRM with your existing systems.",
  },
  {
    image: deployment,
    title: "Training",
    highlight: "& Deployment",
    description: "Your team is trained to maximize the CRM’s potential.",
  },
  {
    image: support,
    title: "Ongoing",
    highlight: "Support",
    description: "We provide continuous updates and technical support to keep your system running smoothly.",
  },
];

const HowItWorks = () => {
  return (
    <section
    className="max-w-[1280px] mx-auto md:px-10 px-5 relative py-7"
    style={
      typeof window !== "undefined" && window.innerWidth >= 768
        ? {
            backgroundImage: `url(${chartImage})`,
            backgroundSize: "contain",
            backgroundPosition: "top right",
            backgroundRepeat: "no-repeat",
          }
        : {}
    }
  >
  
      
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">
          How It Works
        </h2>
        <div className="underline md:w-1/5 w-2/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-black">
          <p className="h-[5px] rounded-xl bg-primary md:w-[50%] w-[70%]"></p>
        </div>
      </div>

      {/* Layout */}
      <div className="flex small:flex-row flex-col gap-5 items-center">
        {/* Left - Steps */}
        <div className=" flex-1 grid small:grid-cols-2 grid-cols-1 small:gap-y-20 gap-y-7 gap-x-5 border-2 border-[#055594] shadow-md border-dashed rounded-[27px] py-7 px-4">
          {steps.map((step, index) => (
            <div key={index} className="flex small:flex-row flex-col gap-4 items-start">
              <img src={step.image} alt={step.title} className="size-[70px] flex-shrink-0" />
              <div>
                <h4 className="text-base sm:text-lg font-bold text-[#FFC300]">
                  {step.title} <span className="text-[#06518C]">{step.highlight}</span>
                </h4>
                <p className="text-sm sm:text-base text-gray-600">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Right - Illustration */}
        <div className="flex flex-[0.6] h-full justify-center ">
         
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
